var _Fragment;
import React from 'react';
import { Heading } from 'reaxl';

/**
 *  The OneClickHeading component displays info specific to the One-Click experience within Email
 */
import { jsx as _jsx, Fragment as _Fragment2, jsxs as _jsxs } from "react/jsx-runtime";
function OneClickHeading() {
  return _Fragment || (_Fragment = /*#__PURE__*/_jsxs(_Fragment2, {
    children: [/*#__PURE__*/_jsx(Heading, {
      size: 400,
      className: "margin-bottom-2",
      children: "Modify Your One-Click Email Settings"
    }), /*#__PURE__*/_jsx("p", {
      children: "Edit your contact details and message to dealers, or change your one-click preference."
    })]
  }));
}
export default OneClickHeading;